<template>
    <div>
        <Modal v-model="show" title="批量面试" :footer-hide="true" width="600">
            <div class="tishi_txt">
                因【大湘内部员工】类型无法导入表格，现新增该功能。可操作【至少2条及以上】数据
                <br>
                只有归属人类型为【大湘内部员工】的面试数据可以进行批量操作。
                <br>
                粘贴当天需要操作的人员姓名数据，可批量的进行【通过】【不通过】(如有同名，请自行检查！)
            </div>


            <div>
                <TablePaste hide-table :input-props="inputProps" :table-props="tableProps" @on-success="handleSuccess"
                    @on-error="handleError" />

                <div class="table_name_main">
                    <div class="name_box">
                        <div v-for="(item, index) in name_list" :key="i" class="namebox">
                            {{ item }}
                        </div>
                    </div>
                </div>

                <div class="button_div">
                    <Button type="primary" @click="tongguo_request">({{ name_list.length }}) 确认通过</Button>
                    <Button style="margin-left:10px" type="error" @click="butongguo_request">({{ name_list.length }}) 确认不通过</Button>
                </div>

            </div>
        </Modal>

    </div>
</template>

<script>
import { http, open_new_page } from "@/utils/http.js";

export default {
    name: "batch_mianshi",
    data() {
        return {
            show: false,
            tabs_index: 0,
            inputProps: {
                rows: 4,
                placeholder: '请输入【姓名】，每行一个人，注意换行！（可粘贴Excel）'
            },
            tableProps: {
                border: true,
                maxHeight: 200
            },
            name_list: [],
            project_id: '',

        }
    },
    methods: {
        // 不通过
        butongguo_request() {
            if (this.name_list.length < 2) {
                this.$Message.error('请输入至少2名人员姓名')
                return;
            }

            var that = this
            var obj = {
                project_id: this.project_id,
                name_list: this.name_list
            }
            http("post", process.env.VUE_APP_HOST + "/my_project/daimianshi/batch_butongguo", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                }
            ).catch((res) => {

                console.log(res, '请求出错')
            })
        },

        tongguo_request() {
            if (this.name_list.length < 2) {
                this.$Message.error('请输入至少2名人员姓名')
                return;
            }

            var that = this
            var obj = {
                project_id: this.project_id,
                name_list: this.name_list
            }
            http("post", process.env.VUE_APP_HOST + "/my_project/daimianshi/batch_tongguo", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                }
            ).catch((res) => {

                console.log(res, '请求出错')
            })
        },

        open(project_id) {
            this.project_id = project_id;
            this.show = true;
        },
        handleSuccess(tableData) {
            console.log('变化')
            var namelist = [];
            console.log(tableData);
            if (tableData) {
                if (tableData.columns.length > 0) {
                    var title_name = tableData.columns[0].title;
                    console.log(222, title_name)
                    namelist.push(title_name);
                }

                for (var i = 0; i < tableData.data.length; i++) {
                    console.log(1111, tableData.data[i].key0);
                    namelist.push(tableData.data[i].key0)
                }

            }
            console.log(namelist)
            this.name_list = namelist;


        },
        handleError(tableData, errorIndex) {
            console.log(tableData, errorIndex);
        }
    }

}
</script>

<style  scoped>
.tishi_txt {
    color: #e17a7a;
}

.table_name_main {
    padding: 10px 0;
}

.namebox {
    padding: 1px 3px;
    background-color: #0466dd;
    color: #fff;
    margin-right: 5px;
    margin-bottom: 5px;
    font-size: 10px;
    border-radius: 3px;
}

.name_box {
    display: flex;
    flex-wrap: wrap;
}

.button_div {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
}
</style>